<template>
  <div>
    <Loader v-if="ready-kunden"/> 
    <transition :name="animations.fadeIn.name" :enter-active-class="animations.fadeIn.enter" :leave-active-class="animations.fadeIn.leave">
      <div class="card" v-if="ready.kunden">
        <div class="card-body">
          <div class="headline">
            <h5>Neueste Kunden</h5>
          </div>
          <div class="table-responsive datatable-vue table-scroll" v-if="sort_rdy">
            <b-table show-empty :items="tableitems.cron_kunden" :fields="tablefields.cron_kunden">
              <template v-slot:cell(name)="row">
                {{ row.item.first_name + " " + row.item.last_name }}
              </template>
              <template v-slot:cell(link)="row">
                <feather type="edit-2" class="infra-blue pointer" @click="$router.push('/admin/dashboard/kunde/' + row.item.id)"></feather>
              </template>
              <template slot="empty">
                <div class='text-center'>
                Keine Kunden gefunden.
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from "@/components/LoaderRelative.vue";

export default {
  name: "WidgetAdminKunden",
  components: {
    Loader
  },
  data() {
    return {
      loading: true,

      sort_rdy: false,
      tablefields: {
        cron_kunden: [
          { key: "name", label: "Name", sortable: false },
          { key: "link", label: "Optionen", sortable: false },
        ],
      },
      tableitems: {
        cron_kunden: [],
      },
    };
  },
  computed: {
    ...mapGetters({
      kunden: "app/kunden",
      ready: "app/readyState",
      animations: "app/animations",
    }),
  },
  created: async function() {
    if (this.kunden == false) {
      try {
        await this.$store.dispatch("app/apiGetKunden");
      } catch (error) {
        console.log(error);
      }
    }

    //assign and sort kunden to display, limit output
    const maxKunden = 5;    
    let allKunden = this.kunden; 

   allKunden.sort(function(a, b) {
      let aDate = new Date(a.created_on);
      let bDate = new Date(b.created_on);
      return bDate - aDate;
    });


    this.tableitems.cron_kunden = allKunden.slice(0, maxKunden);
    this.sort_rdy = true;
  },
};
</script>
